module.exports = __webpack_public_path__ + "img/BACA.79dd5257.png";